<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @openDetailDialog="openDetailDialog"
        @query="getData"
        :disabled="disabled"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      v-if="dialogParamsOptions.visible"
      show-close
      :visible.sync="dialogParamsOptions.visible"
      width="600px"
      :title="dialogParamsOptions.title"
      :close-on-click-modal="false"
      :before-close="() => closeDialog()"
    >
      <edit-from
        ref="editfrom"
        :changeOrderCode="changeOrderCode"
        :disabled="dialogParamsOptions.disabled"
        :code="dialogParamsOptions.code"
        :type="dialogParamsOptions.type"
        @closeDialog="closeDialog"
        @saveOkQuestion="saveOkQuestion"
        @reload="reload"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">
          {{ $l('INDEX.btn_cancel') || '取消' }}</el-button
        >

        <el-button size="small" type="primary" @click="saveReview">
          {{ this.$l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import EditFrom from '../edit-from'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditFrom },
  props: {
    disabled: Boolean,
    changeOrderCode: String,
  },
  data() {
    return {
      usePage: true,
      dialogParamsOptions: {
        type: '',
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  activated() {
    this.getData({ changeOrderCode: this.changeOrderCode })
  },
  methods: {
    getData(form) {
      this.loading = true
      form = {
        changeOrderCode: this.changeOrderCode,
      }
      this.$api
        .changeOrderReviewListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add: this.$l('dialog_title_review_add') || '添加评审意见',
        edit: this.$l('dialog_title_review_edit') || '编辑评审意见',
        addFinal: this.$l('dialog_title_final_review_add') || '添加终审意见',
      }
      this.dialogParamsOptions = {
        visible: true,
        title: types[type],
        code,
        type,
        disabled: type === 'detail',
      }
    },
    closeDialog() {
      this.dialogParamsOptions.visible = false
    },
    saveOkQuestion() {
      this.$emit('saveOkQuestion')
    },
    saveReview() {
      this.$refs.editfrom.saveOrderReview(this.changeOrderCode)
    },
  },
}
</script>
